import React from 'react';
import PageHero from '../components/PageHero';
import { SITE } from '../content/site';

const Contribute: React.FC = () => (
  <div>
    <PageHero
      title="Contribute"
      lead="Issues, pull requests and replications are welcome. Utilities, cooperatives and researchers who want to run the scorecard or the sentinel on their own data can start from the examples, or ask for a no-cost, no-NDA shadow pilot on public data."
    />

    <section className="bg-white section-padding">
      <div className="container-width">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <Card title="Use it" color="bg-primary-red">
            Run the scorecard for your balancing authority or the sentinel on your own load series. The examples use
            public data, so nothing leaves your systems.
          </Card>
          <Card title="Check it" color="bg-light-blue">
            Reproduce a note, report a discrepancy, or propose a better baseline. Replications are credited in the
            archived record.
          </Card>
          <Card title="Extend it" color="bg-dark-gray">
            Add a data source, a metric, a model, or a region. Pull requests follow the contributing guide in each
            repository.
          </Card>
        </div>
      </div>
    </section>

    <section className="bg-gray-50 section-padding">
      <div className="container-width">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="text-3xl font-poppins font-bold text-dark-gray mb-4">Shadow pilot on public data</h2>
            <p className="text-gray-700 mb-4">
              For operators and utilities that want to evaluate the methods without sharing data: a six-to-twelve-week
              shadow pilot on your organization's public EIA-930 or ISO series, with a written report and a
              reproducible notebook. No cost, no NDA, no commitment.
            </p>
            <ul className="space-y-2 text-gray-700 text-sm">
              <li>• Scope agreed in one call; metrics defined up front.</li>
              <li>• Results delivered as a report and a notebook you can rerun.</li>
              <li>• Publication only with your consent.</li>
            </ul>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-poppins font-semibold text-dark-gray mb-4">Get in touch</h3>
            <p className="text-gray-600 mb-6">
              The fastest way is an issue on GitHub. For pilots, collaborations or corrections, email works too.
            </p>
            <div className="space-y-3">
              <a href={SITE.github} target="_blank" rel="noopener noreferrer" className="btn-primary w-full text-center inline-block">
                Open an issue on GitHub
              </a>
              <a href={`mailto:${SITE.email}`} className="btn-outline w-full text-center inline-block">
                {SITE.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

const Card: React.FC<{ title: string; color: string; children: React.ReactNode }> = ({ title, color, children }) => (
  <div className="bg-gray-50 rounded-xl p-8 shadow hover:shadow-lg transition-shadow">
    <div className={`w-12 h-12 ${color} rounded-full mb-4`}></div>
    <h3 className="text-xl font-poppins font-semibold text-dark-gray mb-3">{title}</h3>
    <p className="text-gray-600">{children}</p>
  </div>
);

export default Contribute;
